export interface PromiseAllSettledError<Result> extends Error {
  result: Result[];
  errors: Error[];
}

export const promiseAllSettled = <T>(promises: Promise<T>[]): Promise<T[]> => {
  return new Promise((resolve, reject) => {
    Promise.all(promises.map(promise => promise.catch(e => (isError(e) ? e : new Error(e))))).then(
      (result: (T | Error)[]) => {
        const errors = result.filter(isError);
        const successResults = result.filter(notError);

        if (errors.length) {
          reject({ result: successResults, errors });
        }

        resolve(successResults);
      },
    );
  });
};

export const resolveSettledResourceData = <Data>(data?: Data[], error?: Error): Data[] | null =>
  data || (error && (error as PromiseAllSettledError<Data>).result) || null;

function isError<T>(value: T | Error): value is Error {
  return value instanceof Error;
}

function notError<T>(value: T | Error): value is T {
  return !isError(value);
}
